import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import mscotistaEndpoints from '../../environments/endpoints/mscotista-endpoints';
import { environment } from '../../environments/environment';
import FindAdhesionContractInput from '../models/adhesion/FindAdhesionContractInput';
import { FindAdhesionContractOutput } from '../models/adhesion/FindAdhesionContractOutput';
import SendAdhesionContractInput from '../models/adhesion/SendAdhesionContractInput';
import { SendAdhesionContractOutput } from '../models/adhesion/SendAdhesionContractOutput';
import SignAdhesionContractInput from '../models/adhesion/SignAdhesionContractInput';

@Injectable()
export class MsCotistaService {
  constructor(protected http: HttpClient) {}

  sendAdhesionContract(
    input: SendAdhesionContractInput
  ): Observable<SendAdhesionContractOutput> {
    const url = `${environment.apiCadastroSettings.url}/${mscotistaEndpoints.sendAdhesionContract}`;

    return this.http.post<SendAdhesionContractOutput>(url, input);
  }

  findAdhesionContract(
    input: FindAdhesionContractInput
  ): Observable<FindAdhesionContractOutput> {
    const url = `${environment.apiCadastroSettings.url}/${mscotistaEndpoints.findAdhesionContract}`;

    return this.http.post<FindAdhesionContractOutput>(url, input);
  }

  signsContract(input: SignAdhesionContractInput): Observable<{}> {
    const url = `${environment.apiCadastroSettings.url}/${mscotistaEndpoints.signContract}`;

    return this.http.post(url, input);
  }
}
